function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#A6A6B4",
  d: "M-246-193h1440v339H-246z"
}), React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#FFF",
  d: "M5.07 11.85L3.334 13.4l.265-2.227C2.323 10.342 1.5 9.028 1.5 7.55 1.5 5.037 3.878 3 6.813 3c2.934 0 5.312 2.037 5.312 4.55S9.747 12.1 6.812 12.1c-.61 0-1.196-.088-1.741-.25zm.18-4.95a.638.638 0 0 0 .625-.65c0-.359-.28-.65-.625-.65a.638.638 0 0 0-.625.65c0 .359.28.65.625.65zm3.125 0A.638.638 0 0 0 9 6.25c0-.359-.28-.65-.625-.65a.638.638 0 0 0-.625.65c0 .359.28.65.625.65z"
}), React.createElement("path", {
  fill: "#A6A6B4",
  stroke: "#A6A6B4",
  strokeLinejoin: "round",
  strokeWidth: 0.625,
  d: "M15.13 13.46l.32 2.69-2.137-1.913a5.623 5.623 0 0 1-1.188.125c-2.576 0-4.688-1.724-4.688-3.887 0-2.163 2.112-3.888 4.688-3.888 2.576 0 4.688 1.725 4.688 3.888 0 1.174-.63 2.256-1.682 2.985z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M14.798 13.305l.244 2.06-1.641-1.47c-.404.101-.832.155-1.276.155-2.416 0-4.375-1.6-4.375-3.575 0-1.974 1.959-3.575 4.375-3.575S16.5 8.5 16.5 10.475c0 1.152-.667 2.177-1.702 2.83zm-3.923-3.155a.638.638 0 0 0 .625-.65c0-.359-.28-.65-.625-.65a.638.638 0 0 0-.625.65c0 .359.28.65.625.65zm2.5 0A.638.638 0 0 0 14 9.5c0-.359-.28-.65-.625-.65a.638.638 0 0 0-.625.65c0 .359.28.65.625.65z"
})));

var SvgWechat = function SvgWechat(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWechat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wechat.4b382290.svg";
export { ForwardRef as ReactComponent };